import "../css/api-datatable.css";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";

const ApiDataTable = ({ apiData, index }) => {
  // Convert column-data to row-data
  const rows = apiData[0].data.map((_, rowIndex) => {
    const row = { id: rowIndex }; // ✅ MUI requires an `id` field
    apiData.forEach((col) => {
      row[col.columnName] = col.data[rowIndex];
    });
    return row;
  });

  // Generate columns dynamically
  const columns = apiData.map((col) => ({
    field: col.columnName,
    headerName: col.columnName,
    flex: 1,
    editable: false,
  }));

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <div
        style={{
          width: "100%",
          overflow: "auto",
          height: 300,
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          hideFooter
          density="compact"
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </div>
    </>
  );
};

export default ApiDataTable;
